export default __webpack_public_path__ + "static/media/ntorq-125-fi-moto.3edee7c7.png";